import { type FC } from 'react';
import ClinicFilterSelectBoxV2 from 'components/molecules/include-clinic-select-box';

import s from './styles.module.scss';

import type { TTablePrefix } from 'infrastructure/interfaces';

interface AccountSelectBoxProps {
  tablePrefix: TTablePrefix;
  updateFilter: <T>(newFilter: Partial<T>) => void;
  clinicGuid?: string[];
  parentClinicGuid?: string[];
}

export const AccountsSelect: FC<AccountSelectBoxProps> = ({
  tablePrefix,
  clinicGuid,
  parentClinicGuid,
  updateFilter,
}) => {
  return (
    <div className={s['select-wrapper-accounts']}>
      <ClinicFilterSelectBoxV2
        useAdminApi
        showOnInteractiveTimeDashboard={false}
        included={clinicGuid}
        parentClinicGuid={parentClinicGuid}
        onChange={({ included = [], parentClinicGuid: pC = [] }) => {
          updateFilter({
            [`${tablePrefix}clinicGuid`]: included,
            [`${tablePrefix}parentClinicGuid`]: pC,
            [`${tablePrefix}page`]: undefined,
          });
        }}
      />
    </div>
  );
};
